import { Component, OnInit } from '@angular/core';



import { CommonFunctionService, UserPOSData} from '../../../../services/Common/common-function.service';
import { FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { OrderService } from 'src/app/POS/POSServices/Setup/order.service';
const swal = require('sweetalert');

//import { Role } from './../../settings/view-userdetails/view-userdetails.component';

@Component({
  selector: 'app-order-receipt',
  templateUrl: './order-receipt.component.html',
  styleUrls: ['./order-receipt.component.scss']
  // providers:[OrderServiceService] ,
})
export class OrderReceiptComponent implements OnInit {
  isReadytoUpdaterecipt:boolean=false;
  merchantdata: UserPOSData ;
  isNewRecipt: boolean = true;
  isUpdateRecipt: boolean = false;
  rows;
  TenderAccepted:boolean=false;
  UseLargeFond:boolean=false;
  OrderNotes:boolean=false;
  UserAlternativeInventoryName:boolean=false;

  GroupLineItems:boolean=false;
  ShowModifierName:boolean=false;
  GroupModifiers:boolean=false;

  ShowCustomerInfo:boolean=false;
  SmsReceipt:boolean=false;
  EmailReceipt:boolean=false;

  AddNoofBlankLineTopOfReceipt= new FormControl("", [Validators.required, 
    Validators.pattern('^(?! )(?!0)[0-9]+$')]);
  OrderNumberRollOverAfter= new FormControl("", [Validators.required,Validators.pattern('^(?! )(?!0)[0-9]+$')]);
  OrderNumberType= new FormControl("", [Validators.required]);
  id= new FormControl("", [Validators.required]);
  ContactPerference  = new FormControl("", [Validators.required]);

  constructor(  private router: Router,
    private activatedRoute: ActivatedRoute,
    private service: OrderService,
    private commonfunction: CommonFunctionService) {

     }

  ngOnInit() {
    this.merchantdata = this.commonfunction.getUserPOSData();
    this.getGetorderreciptDetails();
  }

   
  getGetorderreciptDetails() {
    let form = { merchantKeyId: "", id: "", PosSubscriptionId:"" };
    this.activatedRoute.params.subscribe(params => {
      // console.log(params["id"]);
      // console.log(params["merchantKeyId"]);
      form.id = params["id"];
      form.merchantKeyId = params["merchantKeyId"];
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
      // console.log("formdata---" + form);
    });   

    this.service.GetOrderReceiptDetail(form).subscribe(result => {   
      console.log("result.Id---" + result);
     
       if (result.id > 0) {

          this.UseLargeFond = result.useLargeFond ;
         
          this.OrderNotes = result.orderNotes ;
          this.UserAlternativeInventoryName = result.userAlternativeInventoryName ;

          this.GroupLineItems = result.groupLineItems;
          this.ShowModifierName = result.showModifierName;
              this.GroupModifiers = result.groupModifiers;

              this.ShowCustomerInfo = result.showCustomerInfo;
              this.SmsReceipt = result.smsReceipt;
              this.EmailReceipt = result.emailReceipt;

        this.isUpdateRecipt = true;
        this.isNewRecipt = false;
        this.rows = result;
      } else {
        this.isUpdateRecipt = false;
        this.isNewRecipt = true;
      }
    });
 
  }


  UseLargeFond1()
  {
    this.UseLargeFond = !this.UseLargeFond;
  }
  
  OrderNotes1()
  {
    this.OrderNotes = !this.OrderNotes ;
  }

  
  UserAlternativeInventoryName1 ()
  {
    this.UserAlternativeInventoryName = !this.UserAlternativeInventoryName ;
  }

  
  GroupLineItems1 ()
  {
    this.GroupLineItems = !this.GroupLineItems ;
  }

  
  ShowModifierName1 ()
  {
    this.ShowModifierName = !this.ShowModifierName ;
  }

  
  GroupModifiers1 ()
  {
    this.GroupModifiers = !this.GroupModifiers ;
  }

  
  ShowCustomerInfo1 ()
  {
    this.ShowCustomerInfo = !this.ShowCustomerInfo ;
  }

  
  SmsReceipt1 ()
  {
    this.SmsReceipt = !this.SmsReceipt ;
  }

  
  EmailReceipt1()
  {
    this.EmailReceipt = !this.EmailReceipt ;
  
  }
  newOrderReceipt() {
   
    let form = {
      PosSubscriptionId:"",
      CustomerId :"",
      AddNoofBlankLineTopOfReceipt  :"",
      OrderNumberRollOverAfter   :"",
      OrderNumberType :"",
      UseLargeFond:false,
      OrderNotes:false,
      UserAlternativeInventoryName:false,

      GroupLineItems:false,
      ShowModifierName:false,
      GroupModifiers:false,

      ShowCustomerInfo:false,
      SmsReceipt:false,
      EmailReceipt:false,
      };
      form.UseLargeFond = this.UseLargeFond;
      form.OrderNotes = this.OrderNotes;
      form.UserAlternativeInventoryName  = this.UserAlternativeInventoryName ;
      form.GroupLineItems  = this.GroupLineItems;
      form.ShowModifierName = this.ShowModifierName;
      form.GroupModifiers  = this.GroupModifiers ;
      form.ShowCustomerInfo = this.ShowCustomerInfo;
      form.SmsReceipt  = this.SmsReceipt;
      form.EmailReceipt = this.EmailReceipt;
    form.AddNoofBlankLineTopOfReceipt = this.AddNoofBlankLineTopOfReceipt.value;
    form.OrderNumberRollOverAfter  = this.OrderNumberRollOverAfter .value;
    form.OrderNumberType  = this.OrderNumberType .value;
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    form.CustomerId = merchantdata.PosSubscriptionId;
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;
  
    this.service.AddOrderReceipt(form).subscribe(result => {
      console.log(" result - ", result);
      if (result != null) {
        swal("Added", "OrderRecipt Added Successfully ! !", "success");
        this.router.navigate(["/pos/orderreceipt/manage"]);
    }
    });
  }

  updateOrderReceipt()
  {
    let form = {
      PosSubscriptionId:"",
      AddNoofBlankLineTopOfReceipt  :"",
      OrderNumberRollOverAfter  :"",
      OrderNumberType  :"",
       CustomerId :"",
      Id:"",


      UseLargeFond:false,
      OrderNotes:false,
      UserAlternativeInventoryName:false,

      GroupLineItems:false,
      ShowModifierName:false,
      GroupModifiers:false,

      ShowCustomerInfo:false,
      SmsReceipt:false,
      EmailReceipt:false,

      };

      form.UseLargeFond = this.UseLargeFond;
      form.OrderNotes = this.OrderNotes;
      form.UserAlternativeInventoryName  = this.UserAlternativeInventoryName ;
      form.GroupLineItems  = this.GroupLineItems;
      form.ShowModifierName = this.ShowModifierName;
      form.GroupModifiers  = this.GroupModifiers ;
      form.ShowCustomerInfo = this.ShowCustomerInfo;
      form.SmsReceipt  = this.SmsReceipt;
      form.EmailReceipt = this.EmailReceipt;

    form.AddNoofBlankLineTopOfReceipt = this.AddNoofBlankLineTopOfReceipt.value;
    form.OrderNumberRollOverAfter = this.OrderNumberRollOverAfter.value;
    form.OrderNumberType = this.OrderNumberType.value;
    form.Id=this.id.value;

    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    form.CustomerId = merchantdata.PosSubscriptionId;
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;
    
    this.service.UpdateOrderReceipt(form).subscribe(result => {
      console.log(" result - ", result);
      if (result != null) {
        swal("Updated", "OrderRecipt Updated Successfully !", "success");
        this.router.navigate(["/pos/orderreceipt/manage"]);
      }
    });
  }

  AddNoofBlankLineTopOfReceiptError() {
    return this.AddNoofBlankLineTopOfReceipt.hasError("required") ? "AddNoofBlankLineTopOfReceipt is required"
      : this.AddNoofBlankLineTopOfReceipt.hasError("pattern") ? "AddNoofBlankLineTopOfReceipt should be allow only numbers" : "";
  }
  OrderNumberRollOverAfterError() {
    return this.OrderNumberRollOverAfter.hasError("required") ? "OrderNumberRollOverAfter is required"
      : this.OrderNumberRollOverAfter.hasError("pattern") ? "OrderNumberRollOverAfter should be allow only numbers" : "";
  }
  OrderNumberTypeError() {
    return this.OrderNumberType.hasError("required") ? "OrderNumberType is required"
      : this.OrderNumberType.hasError("pattern") ? "OrderNumberType should be allow only numbers" : "";
  }

 
  onKey()
  {
    this.isReadytoUpdaterecipt = true;
  }
}
